export const callBeginCardControlsSession = (guid, history) => {
  return { type: "BEGIN_CARD_CONTROLS_SESSION", guid: guid, history: history };
};

export const callCardControlsGetCardList = () => {
  return { type: "CARD_CONTROLS_GET_CARD_LIST" };
};

export const setCardControlsCardList = (cardListResponse) => {
  return { type: "CARD_CONTROLS_SET_CARD_LIST", cardListResponse: cardListResponse };
};

export const callPinValidation = (agreeNbr, pin) => {
  return { type: "CARD_CONTROLS_PIN_VALIDATION", agreeNbr: agreeNbr, pin: pin };
};

export const setCardControlsValidationPin = (validatePin) => {
  return { type: "CARD_CONTROLS_SET_PIN_VALIDATION", validatePin: validatePin };
};

export const callSaveCardStatus = (status) => {
  return { type: "CARD_CONTROLS_SAVE_CARD_STATUS", status };
};

export const callPinUpdate = (agreeNbr, pin, callback) => {
  return { type: "CARD_CONTROLS_PIN_UPDATE", agreeNbr: agreeNbr, pin: pin, callback: callback };
};

export const getMailingAddress = () => {
  return { type: "CARD_CONTROLS_GET_MAILING_ADDRESS" };
};

export const setMailingAddress = (mailingAddress) => {
  return { type: "CARD_CONTROLS_SET_MAILING_ADDRESS", mailingAddress: mailingAddress };
};

export const getBranches = (zipCode) => {
  return { type: "CARD_CONTROLS_GET_BRANCHES", zipCode: zipCode };
};

export const setBranches = (branches) => {
  return { type: "CARD_CONTROLS_SET_BRANCHES", branches: branches };
};

export const submitCardRepalcement = (agreeNbr, cardType, callback) => {
  return { type: "CARD_CONTROLS_SUBMIT_CARD_REPLACEMENT", agreeNbr: agreeNbr, cardType: cardType, callback: callback };
};

export const resetCardControlFlow = () => {
  return { type: "RESET_CARD_CONTROLS" };
};

export const callGetTravelExemptionEligibility = (agreeNbr, callback) => {
  return {
    type: "GET_TRAVEL_EXEMPTION_ELIGIBILITY",
    agreeNbr: agreeNbr,
    callback: callback,
  };
};

export const setTravelExemptionEligibility = (travelExemptionEligibility) => {
  return {
    type: "SET_TRAVEL_EXEMPTION_ELIGIBILITY",
    travelExemptionEligibility: travelExemptionEligibility,
  };
}

export const callGetCardOwners = () => {
  return { type: "GET_CARD_OWNERS" };
}

export const callGetExistingTravels = () => {
  return { type: "GET_EXISTING_TRAVELS" };
}

export const callCancelExistingTravel = (cardId, exemptionNumber) => {
  return { 
    type: "CANCEL_EXISTING_TRAVEL",
    cardId: cardId,
    exemptionNumber: exemptionNumber};
}



// WEBPACK FOOTER //
// ./src/actions/cardControls.actions.js